<nz-card class="teste import-card" [nzTitle]="cardTitle">
  <ng-template #cardTitle>
    <div class="view-component-title">
      <span class="title">{{'importacao.title'|translateTA}}</span>
    </div>
  </ng-template>
  <div class="config-container">
    <search-input class="search-input-dados no-padding-form-field" [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpdic" [form]="firstFormGroup" [condition]="conditionSearch" entitydesc="Mktpdic" controlname="IDINSTANCE" [placeholder]="'importacao.tabela'|translateTA" fieldname="INSTANCENAME" columnname="IDINSTANCE">
    </search-input>

    <div class="container-label">
      <div class="tem-field company-field" *ngIf="uas.user.companylist.length > 1">
        <label class="tem-field-label">{{'importacao.company'|translateTA}}</label>
        <nz-select nzShowSearch [ngModel]="codecompany" (ngModelChange)="onCompanyChange($event)">
          <nz-option *ngFor="let data of uas.user.companylist" [nzValue]="data.codecompany" [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
        </nz-select>
      </div>
      <div class="margin-top10 actions-row">
        <button nz-button nzType="primary" class="button-margin my-button-class" (click)="openDPARAModal()">
          <nz-icon nzType="setting"></nz-icon> {{'importacao.btn.dpara'|translateTA}}
        </button>
        <button nz-button nzType="primary" class="button-margin my-button-class" (click)="downloadTemplate()">
          <nz-icon nzType="download"></nz-icon> {{'importacao.btn.template'|translateTA}}
        </button>
        <button nz-button nzType="primary" class="button-margin my-button-class" (click)="downloadTable()">
          <nz-icon nzType="download"></nz-icon> {{'importacao.btn.table'|translateTA}}
        </button>
        <input type="file" (change)="uploadFile($event)" style="display: none" #fileInput>
        <button nz-button nzType="primary" class="my-button-class" (click)="fileInput.click()">
          <nz-icon nzType="cloud-upload"></nz-icon> {{'importacao.btn.upload'|translateTA}}
        </button>
        <label class="toogleTest" nz-tooltip [nzTooltipTitle]="'importacao.testModeTooltip'|translateTA">
          <nz-switch [(ngModel)]="isTestMode"></nz-switch>
          <span class="toggle-label">{{'importacao.testMode'|translateTA}}</span>
        </label>
      </div>
    </div>
    <div class="config-info">
      <div class="config-label">{{'importacao.configLabel'|translateTA}}</div>
      <div class="config-values">{{ configId }}</div>
      <div class="config-separator">-</div>
      <div class="config-values">{{ tableName }}</div>
    </div>
  </div>
</nz-card>

<div class="view-component">
  <nz-tabs class="custom-tabs combined-tab" (nzSelectedIndexChange)="onTabChanged($event)">
    <nz-tab [nzTitle]="'importacao.tab.config'|translateTA">
      <div class="content">
        <simple-datagrid #datagridCfg entityName="Mktpuserimportcfg" [parentRow]="parentRow" [selectedRow]="selecteRow" [condition]="conditionCfg" [getCondition]="getConditionFunction" [events]="eventsSubject.asObservable()"></simple-datagrid>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'importacao.tab.imported'|translateTA">
      <div class="content">
        <div class="view-component-tab">
          <div class="content-tab">
            <simple-datagrid #datagridImp entityName="Mktpuserimport" [parentRow]="parentRow" [selectedRow]="selecteRowImp" [condition]="conditionImp" [getCondition]="getConditionImpFunction" nodata="true" [events]="eventsSubject.asObservable()"></simple-datagrid>
          </div>
          <nz-divider nzType="vertical" class="stretch-divider"></nz-divider>
          <div class="content-tab">
            <simple-datagrid #datagridImpLog entityName="Mktpuserimportlog" [parentRow]="parentRow" [condition]="conditionImpLog" nodata="true" [getCondition]="getConditionLogFunction" [events]="eventsSubject.asObservable()"></simple-datagrid>
          </div>
        </div>
      </div>
    </nz-tab>
  </nz-tabs>
</div>
